import { AnchorButton, Button } from '@blueprintjs/core';
import { VInputField } from 'welltrax-ui-components';
import styled from 'styled-components';
import { DialogNoPadding } from '../../../core/components/styles/dialog';
import Drawer from '../../../core/components/commons/Basic/Drawer/Drawer';
import {
  LoadBGColors,
  ParentAndChildStatusCodes
} from '../../dispatch/components/dispatchLoad/types/DispatchBoardTypes';

export interface IFormDraweProps {
  advanced: boolean;
  extended?: boolean;
}

export const BodyContainer = styled.div`
  height: 100%;
  padding: 15px 10px 15px;
`;

export const BodySeparatorDiv = styled.div`
  display: flex;
  & > span {
    width: 50%;
    text-align: end;
    line-height: 35px;
  }
`;

export const WhiteButton = styled(Button)`
  color: white !important;
  & > span {
    color: white !important;
  }
`;

export const WhiteAnchorButton = styled(AnchorButton)`
  color: white !important;
  & > span {
    color: white !important;
  }
`;

export const FormDrawer = styled(Drawer)`
  &,
  & > .container {
    width: 100%;
    min-width: 100%;
  }

  @media (min-width: 650px) {
    ${(props: IFormDraweProps) =>
      props.advanced
        ? props.extended
          ? `width: 750px!important;
     min-width: 750px;`
          : `width: 650px!important;
     min-width: 650px;`
        : `width: 300px!important;
     min-width: 400px;`}
  }
`;

export const ButtonsEndsContainers = styled.div`
  padding: 0 5px 5px;
  display: flex;
  align-items: end;
  justify-content: flex-end;
  margin-top: 5px;
`;

export const StyledSymbolPickerContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  & > label {
    line-height: 75px;
    width: 20%;
    text-align: start;
  }
  & > div {
    width: 80%;
    padding-left: 10px;
    & > div {
      width: 75px;
      height: 75px;
      border: 1px solid #d8dcde;
      border-radius: 4px;
      background-color: #e6ecef;
    }
  }
`;

export const DialogForm = styled(DialogNoPadding)`
  .bp3-card > div:last-child {
    max-height: calc(100vh - 95px);
    overflow: hidden;

    @media (max-width: 450px) {
      height: calc(100% - 35px);
      max-height: calc(100% - 35px);
    }
  }
`;

export const StyledDialog = styled(DialogForm)`
  .bp3-card > div:last-child > div:first-child.container {
    max-height: calc(100vh - 165px);
    overflow: hidden;
  }

  .bp3-card > div:last-child > div:first-child:not(.height-first-container) > div:first-child > .container,
  .bp3-card > div:last-child > div:first-child.height-first-container > div {
    max-height: calc(100vh - 195px);
    overflow: auto;
  }

  .height-first-container > .body-container-terminal-form {
    height: 800px;
  }
`;

interface IIndeterminateButtonContent {
  width?: string;
  refWidth?: number;
}

export const IndeterminateButtonContent = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  width: ${(props: IIndeterminateButtonContent) => (props.width ? props.width : 'auto')};
  & span.tipLabel {
    background: transparent;
    z-index: 1;
    width: fit-content;
    font-weight: 400;
    font-size: 12px;
    padding: 0 2px;
    position: absolute;
    top: 0;
  }

  & .button {
    text-align: left !important;
    font-size: ${(props: IIndeterminateButtonContent) =>
      (props?.refWidth ? props.refWidth < 50 : false) ? '10px' : '14px'};
  }
`;

type IProp = {
  width: number;
};

export const DrawerStyled = styled(Drawer)`
  text-align: left !important;
  width: ${(props: IProp) => props.width}% !important;
  @media screen and (max-width: 650px) {
    width: 100% !important;
  }

  @media screen and (min-width: 650px) and (max-width: 768px) {
    width: 85% !important;
  }

  & > .bp3-card {
    margin-bottom: 0;
  }
`;

export const ProfileSelectStyled = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #fff;
  .bp3-button-text,
  .bp3-icon,
  .bp3-button {
    color: #fff !important;
  }
`;

export const TooltipButtonWrapperStyled = styled.div`
  & span.bp3-popover-wrapper {
    margin: 0 !important;
  }
`;

export const ProfileConfigStyled = styled.div`
  display: flex;
  & .bp3-popover-wrapper {
    margin: 0 !important;
  }

  & .save-profile {
    padding: 5px !important;
    fill: #fff !important;
    color: #fff !important;
    span {
      color: #fff !important;
    }
    & .bp3-spinner.bp3-intent-primary .bp3-spinner-head {
      stroke: #fff;
    }
  }
`;

interface IVInputFieldStyle {
  showPassword: boolean;
}
export const VInputFieldStyle = styled(VInputField)`
  .gsi-form-field-container {
    -webkit-text-security: ${(props: IVInputFieldStyle) => (props.showPassword ? 'none' : 'disc')};
  }
`;

export const VInputPassword = styled.div`
  margin: 35px;
`;

export const ParentAndChildLoadColorsDiv = styled.div`
  height: calc(100% - 5px);
  & .contextItemStyle {
    text-align: start;
  }
  & :not(.ag-row-selected) {
    &.${ParentAndChildStatusCodes.RETURN_REQUESTED} {
      background: ${LoadBGColors.RETURN_REQUESTED}!important;
    }
    &.${ParentAndChildStatusCodes.RETURN_REQUEST_ACCEPTED} {
      background: ${LoadBGColors.RETURN_REQUEST_ACCEPTED}!important;
    }
    &.${ParentAndChildStatusCodes.RETURN_REQUEST_DENIED} {
      background: ${LoadBGColors.RETURN_REQUEST_DENIED}!important;
    }
    &.${ParentAndChildStatusCodes.RETURNED} {
      background: ${LoadBGColors.RETURNED}!important;
    }
    &.${ParentAndChildStatusCodes.UPDATE_REQUESTED} {
      background: ${LoadBGColors.UPDATE_REQUESTED}!important;
    }
    &.${ParentAndChildStatusCodes.PARTIALLY_FINISHED} {
      background: ${LoadBGColors.PARTIALLY_FINISHED}!important;
    }
  }
`;
